<template>
  <authenticated-layout>
    <page-header
      :title="$t('components.AppConfigurationPage.title')"
    />

    <v-container fluid class="pa-0 fill-height" >
      <v-row>
        <v-col cols="3" xl="2" class="border-e" align-self="stretch">
          <v-list color="transparent" density="compact">
            <v-list-subheader>Menu</v-list-subheader>

            <v-list-item
              :to="{ name: 'generalConfiguration' }"
              active-class="bg-primary"
              :title="$t('components.AppConfigurationPage.general_title')"
            />
            <v-list-item
              :to="{ name: 'onboardingConfiguration' }"
              active-class="bg-primary"
              :title="$t('components.AppConfigurationPage.onboarding')"
            />
            <v-list-item
              :to="{ name: 'authenticationConfiguration' }"
              active-class="bg-primary"
              :title="$t('components.AppConfigurationPage.authentication')"
            />
            <v-list-item
              :to="{ name: 'localisationConfiguration' }"
              active-class="bg-primary"
              :title="$t('components.AppConfigurationPage.localisation')"
            />
            <v-list-item
              :to="{ name: 'featureConfiguration' }"
              active-class="bg-primary"
              :title="$t('components.AppConfigurationPage.features')"
            />
            <v-list-item
              :to="{ name: 'themeConfiguration' }"
              active-class="bg-primary"
              :title="$t('components.AppConfigurationPage.theme')"
            />
            <v-list-item
              :to="{ name: 'integrationConfiguration' }"
              active-class="bg-primary"
              :title="$t('components.AppConfigurationPage.integrations')"
            />
          </v-list>

        </v-col>
        <v-col cols="9" xl="10" class="pt-0">
          <router-view/>
        </v-col>
      </v-row>
    </v-container>
  </authenticated-layout>
</template>

<script setup lang="ts">
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
</script>
